import { render } from "./Color.vue?vue&type=template&id=6fb7edc6&scoped=true&ts=true"
import script from "./Color.vue?vue&type=script&lang=ts"
export * from "./Color.vue?vue&type=script&lang=ts"

import "./Color.vue?vue&type=style&index=0&id=6fb7edc6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb7edc6"]])

export default __exports__